import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface SelectConditionTypeStepProps {
  onBack: () => void;
  onSelectActivity: () => void;
  onSelectCharacteristic: () => void;
}

export function SelectConditionTypeStep({
  onBack,
  onSelectActivity,
  onSelectCharacteristic
}: SelectConditionTypeStepProps) {
  return (
    <>
      <DialogHeader>
        <div className="flex items-center">
          <Button variant="ghost" size="icon" className="mr-2 h-7 w-7" onClick={onBack}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <DialogTitle>Add a condition</DialogTitle>
        </div>
        <DialogDescription className="pl-9">
          To create a segment, start by adding a condition
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 py-4">
        <Button
          variant="outline"
          className="w-full justify-between h-auto py-3 px-4 items-center border-border/40 hover:bg-accent/30 hover:border-border/60"
          onClick={onSelectActivity}
        >
          <div className="flex items-center gap-3">
            {/* TODO: Replace with appropriate icon */}
            <span role="img" aria-label="activity" className="text-xl">
              ⚡️
            </span>
            <span className="font-medium text-sm">Subscriber Activity</span>
          </div>
          <ArrowRight className="h-4 w-4 text-muted-foreground" />
        </Button>
        <Button
          variant="outline"
          className="w-full justify-between h-auto py-3 px-4 items-center border-border/40 hover:bg-accent/30 hover:border-border/60"
          onClick={onSelectCharacteristic}
        >
          <div className="flex items-center gap-3">
            {/* TODO: Replace with appropriate icon */}
            <span role="img" aria-label="characteristic" className="text-xl">
              👤
            </span>
            <span className="font-medium text-sm">Subscriber Characteristic</span>
          </div>
          <ArrowRight className="h-4 w-4 text-muted-foreground" />
        </Button>
      </div>
      {/* No footer needed for this step */}
    </>
  );
}
